import type { ReceiptStatus } from "./types";
import { accountStorageScope, getChatStorage } from "./chatStorage";

const listeners = new Set<() => void>();
let snapshot: Record<string, ReceiptStatus> = {};
let loadedKey = "";

function notify() {
  listeners.forEach((listener) => listener());
}

export function subscribeReceipts(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getReceiptSnapshot(): Record<string, ReceiptStatus> {
  return snapshot;
}

export async function loadReceipts(owner: string): Promise<void> {
  const key = `${accountStorageScope(owner)}receipts`;
  if (loadedKey === key) return;
  loadedKey = key;
  snapshot = {};
  notify();
  try {
    const raw = await getChatStorage().getItem(key);
    if (loadedKey !== key) return;
    snapshot = raw ? (JSON.parse(raw) as Record<string, ReceiptStatus>) : {};
    notify();
  } catch (error) {
    console.error("Failed to load change receipts", error);
  }
}

export async function setReceiptStatus(
  owner: string,
  receiptId: string,
  status: ReceiptStatus,
): Promise<void> {
  snapshot = { ...snapshot, [receiptId]: status };
  notify();
  const key = `${accountStorageScope(owner)}receipts`;
  const raw = await getChatStorage().getItem(key);
  const current = raw ? (JSON.parse(raw) as Record<string, ReceiptStatus>) : {};
  await getChatStorage().setItem(key, JSON.stringify({ ...current, [receiptId]: status }));
}
